import { Input, Component, OnInit } from '@angular/core';

// ionic
import { ModalController } from '@ionic/angular';

// providers
import { NewsfeedService } from "../../services/newsfeed.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";

// other libraries
import { TranslateService } from "@ngx-translate/core";

// models
import { Newsfeed } from "../../models/newsfeed";
import { NewsfeedReport } from "../../models/newsfeed-report";

@Component({
    selector: 'app-newsfeed-report',
    templateUrl: './newsfeed-report.component.html',
    styleUrls: ['./newsfeed-report.component.scss'],
})
export class NewsfeedReportComponent implements OnInit {


    public report: NewsfeedReport = new NewsfeedReport;

    public categories: Array<string> = [
        'offensive',
        'sexual',
        'violent',
        'hateful',
        'misleading',
        'infringement',
    ];

    /**
     * newsfeed post for reporting
     *
     * @type Newsfeed
     */
    @Input() newsfeed: Newsfeed;

    /**
     * show form in modal
     *
     * @type boolean
     */
    @Input() modal: boolean = false;

    /**
     * which select type should be used.. alert/popover/action-sheet
     *
     * @type {string}
     */
    public selectType: string = 'popover';

    /**
     * validate state
     *
     * @type {boolean}
     */
    public validate: boolean = false;

    /**
     * Validation errors
     *
     * @type {object}
     */
    public validationErrors: object = {};

    /**
     * validation errors state
     *
     * @type {boolean}
     */
    public hasValidationErrors: boolean = false;

    /**
     * is image upload active
     *
     * @type {boolean}
     */
    public sending: boolean = false;

    /**
      * submit state
      *
      * @type {boolean}
      */
    public submit: boolean = false;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    constructor(
        public translate: TranslateService,
        public modalController: ModalController,
        public plt: PlatformService,
        public overlayService: OverlayService,
        public newsfeedService: NewsfeedService,
    ) { }

    ngOnInit() {
        // get user lang
        this.userLang = this.translate.currentLang;

        if (this.plt.sizeSm) {
            this.selectType = 'action-sheet';
        }

        this.report.newsfeed_id = this.newsfeed.id;
    }

    /**
     * send new marketplacePost
     */
    public reportSave(valid) {

        if (valid) {
            this.submit = true;
            this.validationErrors = {};
            this.validate = true;

            // send
            this.newsfeedService.reportPost(this.report).subscribe(
                (success) => {
                    this.handleSuccess(success);
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    /**
     * close modal window
     *
     * @param boolean modal
     *
     */
    public backClicked(modal = true) {
        if (modal) {
            this.modalController.dismiss({ action: 'close' });
        }
    }

    /**
     * close modal window
     *
     */
    public closeSaved() {
        this.modalController.dismiss({ action: 'saved' });
    }

    private handleSuccess(response) {
        this.overlayService.showSuccess(response.message);
        this.validate = false;
        if (this.modal) {
            // close modal if used..
            this.closeSaved();
        }
        this.submit = false;
    }

    private handleError(response) {
        const data = response.error;

        if (data.fields) {
            for (const field in data.fields) {
                if (data.fields.hasOwnProperty(field)) {
                    this.hasValidationErrors = true;
                    this.validationErrors[field] = data.fields[field].join(' ');
                }
            }
        }

        this.submit = false;
        this.overlayService.showError(data.message);
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.overlayService.closeModals();
    }
}
